'use client';

import { ContactUsForm } from '@/modules/static/presentation/forms';
import { ContactUsFormSchema, useContactUsForm } from  '@/modules/static/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const ContactUsContainer = () => {
	const { execute } = useContactUsForm();

	return (
		<Form.Provider onSubmit={execute} schema={ContactUsFormSchema}>
			<ContactUsForm />
		</Form.Provider>
	);
};
